import React from 'react'
import classNames from 'classnames'

import Typography from '@toasttab/shared/src/components/atoms/Typography/Typography'

const Spotlights = ({ header, body }: { header: any; body: any }) => {
  return (
    <section className='mb-10 lg:mb-16'>
      <div className='ds-wrapper'>
        <div className='ds-container lg:ds-grid'>
          <div className='col-span-4 lg:col-span-12 flex flex-col items-center lg:max-w-[46.5rem] mb-10 mx-auto text-center'>
            <Typography
              as='h2'
              classes='font-effra font-base !leading-[2.5rem] lg:!leading-[3rem] mb-4 !text-[1.938rem] lg:!text-[45px] text-gray-125'
              variation='h2'
            >
              {header.heading}
            </Typography>
            <Typography
              as='p'
              classes='!font-effra mb-4 leading-8 !text-[1.375rem] lg:!text-[1.625rem] text-secondary'
              variation='default'
            >
              {header.description}
            </Typography>
          </div>
          <div className='grid col-span-4 lg:col-span-12 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6'>
            {body.spotlights.map((spotlight: any, i: number) => {
              const spotlightClass = classNames(
                'flex flex-col items-center w-full text-center group/spotlight relative bg-white rounded-base',
                {
                  'lg:!mb-0': i + 1 === body.spotlights.length
                }
              )
              const keyId = `${spotlight.heading}-${i}`
              return (
                <div className={spotlightClass} key={`spl-${keyId}`}>
                  <img
                    alt={spotlight.heading}
                    className='mb-6 w-full max-w-[343px] lg:max-w-[360px] max-h-[200px]'
                    src={spotlight.image}
                  />
                  <Typography
                    allowHtml={false}
                    as='h3'
                    classes='mb-4 px-14 !text-[1.938rem] !leading-[2.5rem] text-gray-125'
                    variation='h3'
                  >
                    {spotlight.heading}
                  </Typography>
                  <Typography
                    allowHtml={false}
                    as='p'
                    classes='!font-normal px-6 !text-[1.25rem] !leading-[1.5rem] text-secondary'
                    variation='default'
                  >
                    {spotlight.description}
                  </Typography>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </section>
  )
}

export default Spotlights
